import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ParentClubProgrammes } from './ParentClubProgrammes';
import { ProgrammeBooking } from './ProgrammeBooking/ProgrammeBooking';

export function ParentClubProgrammesRouting(props: any) {
  return (
    <Switch>
      <Route path="/clubProgrammes" exact render={p => <ParentClubProgrammes {...props} {...p} />} />
      <Route path="/clubProgrammes/:programmeId/booking" exact render={p => <ProgrammeBooking {...props} {...p} />} />
    </Switch>
  );
}
